import React, { useCallback, useMemo, useState } from 'react'
import { AppTitlePage } from '../../../components/AppTitlePage'
import { AppFilterInput } from '../../../components/AppInput/AppFilterInput'
import { AppTable } from '../../../components/AppTable/AppTable'
import { AddPlanMenuTypePopup } from './AddPlanMenuTypePopup'
import { IPopup } from '../CategoriesPage/CategoriesPage'
import { AppBtnColor } from '../../../components/btn/AppBtn'
import { IChooseItems } from '../../../components/mainContent/TableAllDishes'
import { useGetPlanMenuTypeListQuery } from '../../../core/api/PlanMenuTypeApi'
import { useParamsControl } from '../../../utils/useParamsControl'
import {
  IPlanMenuTypeDto,
  IPlanMenuTypeRequest,
} from '../../../core/api/dto/PlanMenuTypeDto'
import { useSentPlanMenuTypeOnFotobox } from './hooks/useSentPlanMenuTypeOnFotobox'
import { useDeletePlanMenuType } from './hooks/useDeletePlanMenuType'
import { AppDeleteFromMainServerPopup } from '../../../entities/AppDeleteFromMainServerPopup/AppDeleteFromMainServerPopup'
import { AppStationPopup } from '../../../entities/AppStationPopup/AppStationPopup'
import { AppFilterEdgeServersList } from '../../../entities/AppFilterEdgeServersList/AppFilterEdgeServersList'

const headerData = [{ title: 'Тип план-меню', colWidth: '95%', sort: 'name' }]

export const PlanMenuTypePage = () => {
  const pageParams = useParamsControl<
    IPlanMenuTypeRequest,
    keyof IPlanMenuTypeRequest
  >({
    withPagination: true,
    whiteList: ['search', 'ordering', 'edge_servers'],
  })
  const {
    data: planMenuTypeList,
    isLoading: isLoadingGet,
    isFetching: isFetchingGet,
  } = useGetPlanMenuTypeListQuery(
    { ...pageParams, archived: '0' },
    { skip: !pageParams },
  )
  const [openCreatePopup, setOpenCreatePopup] = useState<IPopup>({
    active: false,
    id: null,
  })
  const [chooseItems, setChooseItems] = useState<IChooseItems | null>(null)
  const [tableData, setTableData] = useState<IPlanMenuTypeDto[]>([])

  const {
    sentPopup,
    openSentPopup,
    onDeletePlanMenuTypeStation,
    onSendPlanMenuType,
    deleteStations,
    isDeleteMode,
    openDeleteStationPopup,
    closeSentPopup,
    isLoadingSend,
  } = useSentPlanMenuTypeOnFotobox({
    tableData,
    chooseItems,
    setChooseItems,
  })
  const {
    deletePopup,
    closeDeletePopup,
    onDeletePopupHandler,
    onDeleteHandler,
  } = useDeletePlanMenuType(chooseItems, setChooseItems)

  const openEditPopupHandler = useCallback(
    (id: number) => setOpenCreatePopup({ id, active: true }),
    [],
  )

  const closePopupHandler = useCallback(
    () => setOpenCreatePopup({ id: null, active: false }),
    [],
  )

  const tableActions = [
    {
      title: 'Удалить',
      ico: 'basket',
      onClick: onDeletePopupHandler,
    },
    ...(process.env.REACT_APP_TYPE_SERVER === 'MainServer'
      ? [
          {
            title: 'Отправить на станцию',
            ico: 'add',
            onClick: openSentPopup,
          },
        ]
      : []),
  ]

  const actions = useMemo(
    () => [
      {
        btnTitle: 'Создать тип план-меню',
        btnIco: 'add',
        onClick: () =>
          setOpenCreatePopup((prevState) => ({ ...prevState, active: true })),
        color: AppBtnColor.whiteOutlineViolet,
      },
    ],
    [],
  )
  if (!planMenuTypeList) {
    return null
  }

  return (
    <React.Fragment>
      {openCreatePopup.active && (
        <AddPlanMenuTypePopup
          closePopup={closePopupHandler}
          id={openCreatePopup.id}
        />
      )}
      {deletePopup && (
        <AppDeleteFromMainServerPopup
          onClose={closeDeletePopup}
          onDelete={onDeleteHandler}
          onOpenStationPopup={openDeleteStationPopup}
        />
      )}
      {sentPopup && (
        <AppStationPopup
          onClose={closeSentPopup}
          isLoading={isLoadingSend}
          onSendItems={onSendPlanMenuType}
          isDeleteMode={isDeleteMode}
          deleteStations={deleteStations}
          onDeleteStationDishes={onDeletePlanMenuTypeStation}
        />
      )}
      <div className="width-for-page-wrapper">
        <AppTitlePage title="Типы план-меню" actions={actions} />
        <div className="col-7-width-from-1000">
          <div className="filter-block no-wrap mt-20">
            <AppFilterInput
              fullWidth
              searchParam={'search'}
              ico={'search'}
              label={'Поиск'}
              placeholder="Например: обед"
            />
            <AppFilterEdgeServersList fullWidth />
          </div>
          <AppTable
            data={planMenuTypeList}
            headerData={headerData}
            chooseItems={chooseItems}
            chooseMode
            setChooseItems={setChooseItems}
            setTableData={setTableData}
            tableDataSelectors={[
              {
                renderItem: (item) => (
                  <div
                    className={`table-link ${
                      item.archived ? 'delete-item' : ''
                    }`}
                    onClick={() => openEditPopupHandler(item.id)}
                  >
                    {item.name}
                  </div>
                ),
              },
            ]}
            chooseActions={tableActions}
            isLoading={isLoadingGet || isFetchingGet}
          />
        </div>
      </div>
    </React.Fragment>
  )
}
